import React from 'react';

/**
 * Badge que indica se um campo foi editado por humano ou gerado por IA
 * @param {string} campo - Nome do campo para verificar
 * @param {object} analiseV4 - Dados da análise v4 com metadados
 */
function OrigemBadge({ campo, analiseV4 }) {
  if (!analiseV4) return null;

  const camposEditadosHumano = analiseV4.metadados_ia?.campos_editados_humano || [];
  const isHumano = camposEditadosHumano.some(c => campo.startsWith(c) || c.startsWith(campo));

  return isHumano ? (
    <span style={{
      fontSize: '0.7rem',
      background: '#fef3cd',
      color: '#856404',
      padding: '1px 5px',
      borderRadius: '8px',
      marginLeft: '6px',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '3px'
    }}>
      <span className="material-symbols-outlined" style={{ fontSize: '0.85rem' }}>edit</span> Editado
    </span>
  ) : (
    <span style={{
      fontSize: '0.7rem',
      background: '#e8f0fe',
      color: '#1a73e8',
      padding: '1px 5px',
      borderRadius: '8px',
      marginLeft: '6px',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '3px'
    }}>
      <span className="material-symbols-outlined" style={{ fontSize: '0.85rem' }}>smart_toy</span> IA
    </span>
  );
}

export default OrigemBadge;